import { useQuery } from "@tanstack/react-query";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import { CACHE_KEY_TICKETS } from "../../../utils/constants";
import ticketService from "../../../services/ticketService/ticketService";
import { DataSelectType } from "../../../models/DataSelectType";

const useKanbanTickets = (
  page: number,
  pageSize: number,
  filters?: DataSelectType[],
  startDate?: string,
  endDate?: string
) =>
  useQuery<TicketInterface[], Error>({
    queryKey: [CACHE_KEY_TICKETS, page || null, pageSize || null, filters ?? null, startDate ?? null, endDate ?? null],
    queryFn: () => ticketService.GetByFilter(page, pageSize, null, null, filters, startDate, endDate),
    enabled: !!startDate && !!endDate,
    staleTime: 30_000,
    placeholderData: (prev) => prev ?? [],
  });

export default useKanbanTickets;
